<nz-spin [nzSpinning]="loading$ | async">
  <form
    nz-form
    class="form"
    nzLayout="horizontal"
    [formGroup]="printOptionsForm">
    <div class="drawer-form-wrapper">
      <div class="behaviour-card-sec" *ngIf="caseParams.case">
        <div class="header-with-cta mb-24">
          <h3 class="title s-18">
            {{ caseParams.case.student.firstName }}
            {{ caseParams.case.student.lastName }}
          </h3>
        </div>
        <div class="card-content-wrapper">
          <div class="content">
            <h4 class="title">Date Of Birth</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"
                aria-label="Calendar"></svg-icon>
              {{ caseParams.case.student.dateOfBirth | date: 'MM/dd/yyyy' }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Supervisor</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-supervisor.svg"
                class="icon s-16"
                aria-label="Supervisor"></svg-icon>
              {{ caseParams.case.supervisorName || '-' }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Gender</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-male.svg"
                class="icon s-16"
                aria-label="Male"></svg-icon>
              {{ caseParams.case.student.gender }}
            </p>
          </div>
        </div>
      </div>
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">Available Options</h3>
      </div>
      <ng-container>
        <div class="filter-wrapper">
          <app-graph-filter
            (filterChange)="onFilterChange($event)"></app-graph-filter>
          <nz-form-item class="mt-16">
            <nz-form-label nzFor="frequencyInterval"
              >Show Frequency Interval?</nz-form-label
            >
            <nz-form-control nzErrorTip="Please select one option.">
              <nz-select
                nzAllowClear
                nzPlaceHolder="Select"
                id="frequencyInterval"
                name="frequencyInterval"
                formControlName="frequencyInterval"
                (ngModelChange)="this.resetGraphs()">
                <nz-option nzLabel="Yes" [nzValue]="true"></nz-option>
                <nz-option nzLabel="No" [nzValue]="false"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="mt-16">
          <nz-form-item>
            <nz-form-label nzFor="comment"> Comment </nz-form-label>
            <nz-form-control>
              <textarea
                id="comment"
                name="comment"
                rows="4"
                nz-input
                formControlName="comment"
                placeholder="Enter report comment"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </ng-container>
      <nz-form-item>
        <div class="checkbox-wrapper">
          <span nz-checkbox formControlName="isDraft"
            >Print with DRAFT watermark</span
          >
          <span
            nz-checkbox
            formControlName="isGraph"
            [nzDisabled]="
              printOptionsForm.value.startDate === null ||
              printOptionsForm.value.endDate === null ||
              printOptionsForm.get('startDate')?.invalid ||
              printOptionsForm.get('endDate')?.invalid
            "
            [nzChecked]="printOptionsForm.value.isGraph"
            (nzCheckedChange)="onOptionsCheckboxChange($event)"
            >Add graphs to report</span
          >
          <span
            nz-checkbox
            formControlName="isComments"
            [nzDisabled]="
              printOptionsForm.value.startDate === null ||
              printOptionsForm.value.endDate === null ||
              printOptionsForm.get('startDate')?.invalid ||
              printOptionsForm.get('endDate')?.invalid ||
              printOptionsForm.get('isGraph')?.value === false
            "
            [nzChecked]="printOptionsForm.get('isComments')?.value"
            (nzCheckedChange)="onCommentCheckboxChange($event)"
            >Add Comments to report</span
          >
          <span nz-checkbox formControlName="isIncludeStrategyGuidelines"
            >Include Strategy Guidelines</span
          >
        </div>
      </nz-form-item>
      <nz-table
        *ngIf="graphList.length > 0"
        #basicTable
        [nzData]="graphList"
        [nzFrontPagination]="false">
        <thead>
          <tr>
            <th scope="col" nzWidth="70px" nzAlign="center">Print</th>
            <th scope="col" nzWidth="200px">Behavior</th>
            <th scope="col" nzWidth="200px">Graph Name</th>
            <th scope="col" nzWidth="200px">Date Range</th>
          </tr>
        </thead>
        <tbody>
          @for (data of basicTable.data; track data) {
            <tr>
              <td nzWidth="70px" nzAlign="center">
                <span
                  [nzDisabled]="
                    !printOptionsForm.get('startDate')?.value ||
                    !printOptionsForm.get('endDate')?.value
                  "
                  nz-checkbox
                  [nzChecked]="checkedGraphList.includes(data)"
                  (nzCheckedChange)="
                    onGraphCheckboxChange($event, data)
                  "></span>
              </td>
              <td nzWidth="200px">{{ data.behaviorCategoryName }}</td>
              <td nzWidth="200px">{{ data.unitName }}</td>
              <td nzWidth="200px">
                {{ data.startDataDate | userDate: 'MM/dd/yyyy' }} -
                {{ data.endDataDate | userDate: 'MM/dd/yyyy' }}
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
      <div
        class="header-with-cta without-border"
        *ngIf="activePlanAttachments.length > 0">
        <h3 class="title s-18">Other uploaded documents</h3>
      </div>
      <div class="mb-8" *ngIf="activePlanAttachments.length > 0">
        <div
          class="custom-data-wrapper"
          *ngFor="let attachment of activePlanAttachments; let k = index">
          <h3 class="title s-18 ms-8 p-16">{{ attachment.planTypeName }}</h3>
          <div
            *ngFor="
              let item of getFilteredPdfAttachments(attachment.attachments)
            "
            class="data">
            <span
              nz-checkbox
              [nzChecked]="checkedAttachments.includes(item)"
              (nzCheckedChange)="onAttachmentCheckboxChange($event, item)"
              >{{ item.name }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button type="button" nzType="default" (click)="onCancel()">
        Cancel
      </button>
      <button nz-button type="button" nzType="primary" (click)="getGraphData()">
        Print
      </button>
    </div>
  </form>
</nz-spin>
